import { render } from "./StartPanel.vue?vue&type=template&id=002d81b8&scoped=true"
import script from "./StartPanel.vue?vue&type=script&lang=js"
export * from "./StartPanel.vue?vue&type=script&lang=js"

import "./StartPanel.vue?vue&type=style&index=0&id=002d81b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002d81b8"]])

export default __exports__